import type { LucideIcon } from 'lucide-react'
import { GRAY_200, GRAY_400, GRAY_700 } from '../tokens'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  subtitle?: string
}

/** Standardizes the several empty-state screens the audit found (Class Tests,
 * Content Library, Flagged Content, Practice History) into one look. */
export function EmptyState({ icon: Icon, title, subtitle }: EmptyStateProps) {
  return (
    <div style={{ textAlign: 'center', padding: '3rem 2rem' }}>
      <Icon size={40} color={GRAY_200} style={{ marginBottom: '0.8rem' }} />
      <div style={{ color: GRAY_700, fontWeight: 700, marginBottom: '0.3rem' }}>{title}</div>
      {subtitle && <div style={{ color: GRAY_400, fontSize: '0.92rem' }}>{subtitle}</div>}
    </div>
  )
}
